import { defineComponent as be, ref as I, computed as r, watch as ge, createElementBlock as x, openBlock as p, createVNode as f, createCommentVNode as T, unref as c, withCtx as u, withDirectives as ke, createBlock as O, vShow as we, mergeProps as q, normalizeClass as Ie, createElementVNode as K, toDisplayString as b, createTextVNode as D, nextTick as Te } from "vue";
import "@popperjs/core";
import { RevDrawer as ye } from "@ds/components/Drawer";
import F from "../InputSelect/components/InputSelectButton.vue2.js";
import { RevInputText as Ce } from "@ds/components/InputText";
import { RevLink as Ee } from "@ds/components/Link";
import { RevPopover as xe } from "@ds/components/Popover";
import Oe from "../../icons/generated/IconSearch.vue2.js";
import { useI18n as Ve } from "@ds/plugin";
import Pe from "../../translations/generic.translations.js";
import { isEmpty as Be } from "../../utils/isEmpty.js";
import { scrollToElement as Ae } from "../../utils/scrollToElement.js";
import { tw as M } from "../../utils/tailwind.js";
import "@ds/components/Backdrop";
import "@ds/components/ButtonIcon";
import "@ds/components/Portal";
import "@ds/components/Icon";
import { openModal as Se, closeModal as G } from "../ModalBase/ModalBase.helpers.js";
import { defaultScrollToElementTimeout as De, LIST_ITEM_HEIGHT_WITH_DESCRIPTION as Me, LIST_ITEM_HEIGHT as He, SEARCH_ITEM_HEIGHT as Le, MARGIN as z, NO_ACTIVE_OPTION as H } from "./InputSelectSearchable.constant.js";
import { isOptionsGroup as Ne } from "./InputSelectSearchable.helpers.js";
import j from "./components/InputSelectSearchableOptionsList.vue2.js";
import Q from "./components/InputSelectSearchableSearch.vue2.js";
const _e = { class: "relative" }, $e = {
  key: 0,
  class: "relative flex items-center"
}, Ue = { class: "pl-12 pr-32 pt-20" }, Re = {
  key: 0,
  class: "md:hidden"
}, qe = { class: "pl-12 pr-32 pt-20" }, Ke = ["id"], L = "input-select-searchable-mobile-drawer", mo = /* @__PURE__ */ be({
  name: "RevInputSelectSearchable",
  __name: "InputSelectSearchable",
  props: {
    clearButtonAriaLabel: {},
    disabled: { type: Boolean, default: !1 },
    error: { default: void 0 },
    hideCheckboxes: { type: Boolean, default: !1 },
    id: {},
    label: {},
    listboxPlacement: { default: "auto" },
    modelValue: {},
    modifiers: { default: () => [] },
    noOptionsMessage: {},
    defaultOption: { default: void 0 },
    options: {},
    scrollToElementTimeout: { default: De },
    searchPlacement: { default: "field" },
    searchPlaceholder: { default: void 0 },
    required: { type: Boolean, default: !1 }
  },
  emits: ["text-change", "update:modelValue", "focus", "clear"],
  setup(W, { emit: J }) {
    const n = W, y = J, X = Ve(), v = I(""), C = I(!1), h = r(() => n.searchPlacement === "dropdown"), Y = r(() => {
      if (n.options.length < 6)
        return "";
      const e = n.options.slice(0, 6), o = (a) => a.description ? Me : He, t = e.reduce(
        (a, m) => a + o(m),
        0
      ), l = h.value ? Le + z : z;
      return `${t + l}px`;
    }), Z = r(() => [
      {
        name: "flip",
        options: {
          allowedAutoPlacements: ["top", "bottom"]
        }
      },
      ...n.modifiers
    ]), i = I(H), V = I(!1), g = r(
      () => n.options.reduce(
        (e, o) => e.concat(Ne(o) ? o.options : o),
        []
      )
    ), P = r(
      () => Object.fromEntries(g.value.map(({ id: e }, o) => [e, o]))
    ), d = r({
      get() {
        return n.modelValue;
      },
      set(e) {
        y("update:modelValue", e);
      }
    }), k = r(() => `${n.id}-listbox`);
    function B(e = !0) {
      return e ? g.value[i.value]?.id : void 0;
    }
    function A() {
      return d.value ? d.value.label : "";
    }
    const w = I(A());
    function E(e) {
      w.value = e, v.value = "", y("text-change", e);
    }
    function ee(e, o) {
      o(), y("focus", e);
    }
    function oe() {
      C.value = !0;
    }
    function te() {
      C.value = !1;
    }
    ge(d, (e) => {
      E(e ? e.label : "");
    });
    function le(e) {
      V.value || (E(A()), e());
    }
    const ae = r(
      () => n.options.filter(
        (e) => e.label.toLowerCase().includes(v.value.toLowerCase())
      )
    ), N = r(() => {
      const e = d.value, o = ae.value;
      return h.value && e ? [e, ...o.filter((t) => t.id !== e.id)] : o;
    });
    function ne(e, o, t) {
      e ? o() : t();
    }
    function ie(e, o, t) {
      i.value = H, e || o(), E(t ? t.toString() : "");
    }
    function _(e) {
      d.value = null, e(), y("clear");
    }
    function S(e) {
      return d.value ? e.id === d.value.id : !1;
    }
    async function $(e) {
      d.value = S(e) ? null : e, await Te(), E(A());
    }
    function re(e, o, t, l) {
      if (e.preventDefault(), !B(l)) {
        o();
        return;
      }
      t(), $(g.value[i.value]);
    }
    function se(e, o) {
      e.currentTarget.blur(), o();
    }
    function de(e, o, t) {
      if (Be(g.value))
        return;
      if (e.preventDefault(), !t) {
        o();
        return;
      }
      const { length: l } = g.value;
      switch (e.key) {
        case "PageUp":
        case "Home":
          i.value = 0;
          break;
        case "PageDown":
        case "End":
          i.value = l - 1;
          break;
        // ArrowUp or ArrowDown
        default:
          if (i.value === H)
            i.value = e.key === "ArrowUp" ? l - 1 : 0;
          else {
            const s = { ArrowUp: -1, ArrowDown: 1 }[e.key];
            i.value = (i.value + l + s) % l;
          }
      }
      const a = String(B()), m = document.getElementById(a);
      m && Ae(m, {
        timeout: n.scrollToElementTimeout,
        scroll: { behavior: "instant", block: "nearest" }
      });
    }
    function U(e, o, t, l) {
      switch (e.key) {
        case "Enter":
          re(e, o, t, l);
          break;
        case "Escape":
          se(e, t);
          break;
        case "ArrowDown":
        case "PageDown":
        case "End":
        case "ArrowUp":
        case "PageUp":
        case "Home":
          de(e, o, l);
          break;
      }
    }
    function ue(e) {
      i.value = P.value[e.id];
    }
    function ce() {
      V.value = !0;
    }
    function pe(e, o, t) {
      e.preventDefault(), V.value = !1, t(), $(o);
    }
    function R(e, o) {
      return {
        mousemove: () => ue(e),
        mousedown: () => ce(),
        click: (t) => pe(t, e, o)
      };
    }
    function me() {
      _(() => G(L));
    }
    const fe = r(() => [
      n.error && M`border-action-danger-low focus-visible:border-action-danger-low-focus focus-visible:outline-danger-low`
    ]), ve = r(() => [
      M`text-action-default-hi pointer-events-none absolute right-12 shrink-0 select-none`,
      n.disabled && M`text-static-default-low-disabled`
    ]), he = r(() => `${n.id}_error`);
    return (e, o) => (p(), x("div", _e, [
      f(c(xe), {
        "content-class-names": "z-10 w-full",
        modifiers: Z.value,
        position: e.listboxPlacement
      }, {
        trigger: u(({ show: t, hide: l, isOpen: a, ...m }) => [
          h.value ? (p(), O(F, q({
            key: 1,
            id: e.id
          }, m, {
            "aria-controls": k.value,
            "aria-expanded": a,
            class: "hidden md:flex",
            disabled: e.disabled,
            focused: C.value,
            "has-error": !!e.error,
            "has-selected-option": !!w.value,
            required: e.required,
            role: "combobox",
            "select-id": e.id,
            onBlur: te,
            onClick: () => ne(a, l, t),
            onFocus: oe,
            onKeydown: (s) => U(s, t, l, a)
          }), {
            label: u(() => [
              D(b(e.label), 1)
            ]),
            value: u(() => [
              K("div", Ue, b(d.value?.label), 1)
            ]),
            _: 1
          }, 16, ["id", "aria-controls", "aria-expanded", "disabled", "focused", "has-error", "has-selected-option", "required", "select-id", "onClick", "onKeydown"])) : (p(), x("div", $e, [
            f(c(Ce), q({ id: e.id }, m, {
              "aria-activedescendant": B(a),
              "aria-autocomplete": "list",
              "aria-controls": k.value,
              "aria-expanded": String(a),
              autocomplete: "off",
              class: "w-full",
              "clear-button-aria-label": e.clearButtonAriaLabel,
              disabled: e.disabled,
              "input-class": fe.value,
              label: e.label,
              "model-value": w.value,
              role: "combobox",
              onBlur: (s) => le(l),
              onClear: (s) => _(l),
              onFocus: (s) => ee(s, t),
              onKeydown: (s) => U(s, t, l, a),
              "onUpdate:modelValue": (s) => ie(a, t, s)
            }), null, 16, ["id", "aria-activedescendant", "aria-controls", "aria-expanded", "clear-button-aria-label", "disabled", "input-class", "label", "model-value", "onBlur", "onClear", "onFocus", "onKeydown", "onUpdate:modelValue"]),
            w.value ? T("", !0) : (p(), O(c(Oe), {
              key: 0,
              class: Ie(ve.value),
              size: "20"
            }, null, 8, ["class"]))
          ]))
        ]),
        content: u(({ isOpen: t, hide: l }) => [
          ke(f(j, {
            "active-option-index": i.value,
            class: "mt-8",
            "default-option": e.defaultOption,
            "flat-option-indexes": P.value,
            "get-list-item-listeners": R,
            hide: l,
            "hide-checkbox": n.hideCheckboxes,
            "is-option-selected": S,
            "list-id": k.value,
            "max-height": Y.value,
            "no-options-message": e.noOptionsMessage,
            options: N.value,
            "search-placement": e.searchPlacement,
            view: "desktop"
          }, {
            search: u(() => [
              h.value ? (p(), O(Q, {
                key: 0,
                modelValue: v.value,
                "onUpdate:modelValue": o[0] || (o[0] = (a) => v.value = a),
                "search-placeholder": e.searchPlaceholder
              }, null, 8, ["modelValue", "search-placeholder"])) : T("", !0)
            ]),
            _: 1
          }, 8, ["active-option-index", "default-option", "flat-option-indexes", "hide", "hide-checkbox", "list-id", "max-height", "no-options-message", "options", "search-placement"]), [
            [we, t]
          ])
        ]),
        _: 1
      }, 8, ["modifiers", "position"]),
      h.value ? (p(), x("div", Re, [
        f(F, {
          id: e.id,
          "aria-owns": k.value,
          disabled: e.disabled,
          focused: C.value,
          "has-error": !!e.error,
          "has-selected-option": !!w.value,
          required: e.required,
          role: "combobox",
          "select-id": e.id,
          onClick: o[1] || (o[1] = (t) => c(Se)(L))
        }, {
          label: u(() => [
            D(b(e.label), 1)
          ]),
          value: u(() => [
            K("div", qe, b(d.value?.label), 1)
          ]),
          _: 1
        }, 8, ["id", "aria-owns", "disabled", "focused", "has-error", "has-selected-option", "required", "select-id"]),
        f(c(ye), {
          "has-padding": !1,
          name: "input-select-searchable-mobile-drawer",
          title: e.label
        }, {
          beforeTitle: u(() => [
            f(c(Ee), { onClick: me }, {
              default: u(() => [
                D(b(c(X)(c(Pe).buttonClear)), 1)
              ]),
              _: 1
            })
          ]),
          body: u(() => [
            h.value ? (p(), O(Q, {
              key: 0,
              modelValue: v.value,
              "onUpdate:modelValue": o[2] || (o[2] = (t) => v.value = t),
              class: "border-static-default-low border-b-1",
              "search-placeholder": e.searchPlaceholder
            }, null, 8, ["modelValue", "search-placeholder"])) : T("", !0),
            f(j, {
              "active-option-index": i.value,
              class: "rounded-none",
              "default-option": e.defaultOption,
              "flat-option-indexes": P.value,
              "get-list-item-listeners": R,
              hide: () => c(G)(L),
              "hide-checkbox": n.hideCheckboxes,
              "is-option-selected": S,
              "list-id": k.value,
              "no-options-message": e.noOptionsMessage,
              options: N.value,
              "search-placement": e.searchPlacement,
              view: "mobile"
            }, null, 8, ["active-option-index", "default-option", "flat-option-indexes", "hide", "hide-checkbox", "list-id", "no-options-message", "options", "search-placement"])
          ]),
          _: 1
        }, 8, ["title"])
      ])) : T("", !0),
      e.error ? (p(), x("p", {
        key: 1,
        id: he.value,
        class: "text-static-danger-hi body-2 mt-8",
        role: "alert"
      }, b(e.error), 9, Ke)) : T("", !0)
    ]));
  }
});
export {
  mo as default
};
